// @flow
const container = {
  textAlign: 'center',
};

export default { container };



// WEBPACK FOOTER //
// ./src/scenes/User/style.js